import React from 'react';
import { Navigate } from 'react-router-dom';
import { ensureOrganizationId } from '../utils/organization';
import { canAccessAmplify, canCreateEnrichment } from '../utils/permissions';

const isAuthenticated = () =>
    Boolean(
        localStorage.getItem('isAuthenticated') &&
        localStorage.getItem('cty') &&
        localStorage.getItem('selectedItems') &&
        localStorage.getItem('selectedCountry') &&
        localStorage.getItem('companies') &&
        localStorage.getItem('companyFilter')
    );

export function ProtectedRoute({ children }) {
    if (!isAuthenticated()) {
        return <Navigate to="/iniciar-sesion" />;
    }

    ensureOrganizationId();

    return <>{children}</>;
}

export function ProtectedRouteCapability({ children, capability }) {
    if (!isAuthenticated()) {
        return <Navigate to="/iniciar-sesion" />;
    }

    ensureOrganizationId();

    if (capability === 'amplify' && !canAccessAmplify()) {
        return <Navigate to="/acceso-denegado" />;
    }

    if (capability === 'createEnrichment' && !canCreateEnrichment()) {
        return <Navigate to="/acceso-denegado" />;
    }

    return <>{children}</>;
}
